<template>
  <div class="index">
    <div class="header sd-flex-between">
      <div class="connectUs sd-flex-row"></div>
      <com-social-sharing/>
    </div>
    <div class="nav sd-flex-between" :class="scrollTop>300?'fixedTop animated fadeInDownBig':''">
      <div class="logo">
        <img :src="logo" alt="">
      </div>
      <div class="navigation">
        <el-menu mode="horizontal" :default-active="activeIndex" @select="handleSelect">
          <el-menu-item v-for="(val,i) in nav"
                        :key="i"
                        :index="val.index">
            {{val.name}}
          </el-menu-item>
        </el-menu>
      </div>
    </div>
    <div class="main">
      <router-view/>
    </div>
    <div class="footer">
      <com-footer/>
    </div>
  </div>
</template>

<script>
  /**
   * @Class: pages
   * @Module: index
   * @Description: 索引
   * @Version: 1.0.0
   ---- Created by "Sitdown.liu<731225377@qq.com>" on "2020/04/28 11:09:22" ---*/
  import logo from '@/assets/img/logo.png';

  export default {
    data() {
      return {
        logo,
        activeIndex: "1",
        path: {
          "1": "/home",
          "2": "/product",
          "3": "/about",
          "4": "/case",
          "5": "/connect",
        },
        nav: [
          {index: "1", name: "首页"},
          {index: "2", name: "产品介绍"},
          {index: "3", name: "关于我们"},
          {index: "4", name: "优秀案例"},
          {index: "5", name: "联系我们"},
        ],
        scrollTop: 0,
      };
    },

    mounted() {
      window.addEventListener('scroll', this.handleScrollTop)
    },

    created() {
      this.$set(this, "activeIndex", this.$route.meta.level);
    },

    methods: {
      /**
       * 主导航
       * @param index 索引
       */
      handleSelect(index) {
        this.$router.push(this.path[index]);
      },

      handleScrollTop() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        this.$set(this, "scrollTop", scrollTop);
      },
    },
  };
</script>

<style lang="less">
  .index {
    width: 100%;

    .header {
      background: #6CC5D9;
      padding: 5px 40px;
      color: #ffffff;
      align-items: center;

      .connectUs {
        align-items: center;

        .item {
          align-items: center;
          padding-right: 15px;
          line-height: 24px;

          i {
            font-size: 16px;
            position: relative;
            bottom: 2px;
          }

          .name {
            font-size: 13px;
            padding: 0 5px;
          }

          .value {
            font-size: 13px;
          }
        }
      }

    }

    .nav {
      background: #ffffff;
      padding: 0 15%;
      align-items: center;

      &.fixedTop {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background: #ffffff;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
        z-index: 9999999;
      }

      .logo {
        height: 60px;
        width: 360px;
        text-align: center;
        line-height: 58px;
        color: #ffffff;
        padding: 10px 0;

        img {
          height: 40px;
        }
      }

      .navigation {
        .el-menu {
          border-bottom: 0;

          .el-menu-item {
            color: #333333;

            &.is-active {
              background: #ECF5FF;
              border-bottom: 2px solid #6CC5D9;
              color: #31708f;
              font-weight: 600;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue